import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CartComponent from 'shared/product_tabs/cart/components/Cart';
import { buildProjectNumber } from 'shared/product_tabs/cart/utils/builders';
import { deleteFabrication } from 'offshore_pcb/pcb_fabrication/slice/fabricationSlice';
import { buildFabricationForm } from 'offshore_pcb/pcb_fabrication/utils/builder';
import { validate, validateProject } from 'offshore_pcb/pcb_fabrication/slice/validators';
import {
  selectFabricationCurrentVariant,
  selectFabricationDataForCart,
} from 'offshore_pcb/pcb_fabrication/slice/selectors';

const Cart = () => {
  const dispatch = useDispatch();

  const currentFabricationVariant = useSelector(selectFabricationCurrentVariant);

  const cleanUp = () => dispatch(deleteFabrication());
  const fabricationValidate = () => dispatch(validate());
  const projectValidate = () => dispatch(validateProject());

  const projectNumber = () => Spree.project_number || buildProjectNumber(`PL${currentFabricationVariant}`, 24);
  const projectReference = () => 'offshore-pcbs';

  return (
    <CartComponent
      fabricationSelector={selectFabricationDataForCart}
      fabricationCleanUp={cleanUp}
      fabricationValidate={fabricationValidate}
      projectValidate={projectValidate}
      buildFabricationForm={buildFabricationForm}
      projectNumber={projectNumber}
      projectReference={projectReference} />
  );
};

export default Cart;
